<template>
<div>
  <div class="search">
    <!-- 侧拉抽屉 筛选 start -->
    <el-drawer
      title="我是标题"
      :visible.sync="showDrawer"
      size="300px"
      :modal-append-to-body="false"
      :wrapperClosable="true"
      :with-header="false">
      <div class="drawer_box">
        <div class="drawer_main_content">
          <div class="header" v-if="showCate">
            <p class="head_title">Category</p>
          </div>
          <div class="header" v-else>
            <p class="head_title">Filter</p>
            <p class="head_clear" @click="clearAllHandel()">Clear all</p>
          </div>

            <template  v-if="showCate">
              <div class="all-product" @click="clearBrandHandel">All Products</div>
              <el-collapse v-model="activeNames" :accordion="true" class="cust-collapse" @change="handleChange">
                <el-collapse-item v-for="(itm,index) in cateArr" :key="index" class="cust-collapse-itm" :name="itm.cateName" @click="queryDataByBrand( itm)">
                  <template slot="title">
                    {{itm.cateName}}
                    <i class="cust-lg-i" :class="{'cust-lg-i-active':activeNames==itm.cateName}"></i>
                  </template>
                  <div v-for="(itm2,idx) in itm.childrenList" class="brand-app-cate" :class="{'brand-app-cate-active':tmpCategoryId==itm2.id}" @click="queryDataByBrand( itm2)">
                      <a href="javascript:void(0)">
                        {{itm2.cateName}}
                      </a>
                    </div>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-else>
              <el-collapse v-model="activeNames"  @change="handleChange">
              <el-collapse-item title="Brand" name="1" v-if="type =='product'">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="selectData.collectionBrandId" v-for="(item,index) in brandOption" :key="index" @change="getList(false)">
                      <el-radio :label="item.collectionBrandId">{{item.collectionBrandName}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Wholesale Price" name="2">
                <div class="cate_list">
                  <p class="price_cahnge_info">Price Range</p>
                  <div class="price_input">
                    <el-input  v-model="selectData.minPrice" placeholder="$Min"></el-input>
                    <span>-</span>
                    <el-input  v-model="selectData.maxPrice" placeholder="$Max"></el-input>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Hair Material" name="3" v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="hairMaterialItem" v-for="(item,index) in hairMaterialOption" :key="index" @change="addSelectList">
                      <el-radio :label="item">{{item}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Hair Texture" name="4" v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="hairTextureItem" v-for="(item,index) in hairTextureOption" :key="index" @change="addSelectList">
                      <el-radio :label="item">{{item}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Hair Lace Design" name="5" v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="hairLaceDesignItem" v-for="(item,index) in hairLaceDesignOption" :key="index" @change="addSelectList">
                    <el-radio :label="item">{{item}}</el-radio>
                  </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Hair Type" name="6" v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="hairTypeItem" v-for="(item,index) in hairTypeOption" :key="index" @change="addSelectList">
                    <el-radio :label="item">{{item}}</el-radio>
                  </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>

              <!-- Dresses部分的属性 -->
              <el-collapse-item title="Style" name="7" v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="dressesStyleItem" v-for="(item,index) in dressesStyleOption" :key="index" @change="addSelectList">
                    <el-radio :label="item">{{item}}</el-radio>
                  </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Design" name="8" v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="dressesDesignItem" v-for="(item,index) in dressesDesignOption" :key="index" @change="addSelectList">
                    <el-radio :label="item">{{item}}</el-radio>
                  </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Fabric Type" name="9" v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)">
                <div class="cate_list">
                  <div class="cate_list_radio">
                    <el-radio-group v-model="dressesFabricTypeItem" v-for="(item,index) in dressesFabricTypeOption" :key="index" @change="addSelectList">
                    <el-radio :label="item">{{item}}</el-radio>
                  </el-radio-group>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Occasion" name="10" v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)">
            <div class="cate_list">
              <div class="cate_list_radio">
                <el-radio-group v-model="dressesOccasionItem" v-for="(item,index) in dressesOccasionOption" :key="index" @change="addSelectList">
                <el-radio :label="item">{{item}}</el-radio>
              </el-radio-group>
              </div>
            </div>
          </el-collapse-item>
              </el-collapse>
            </template>

        </div>

        <div class="drawer_footer" v-if="!showCate">
          <el-button class="footer_button" type="primary" @click="closeHandel()">Apply</el-button>
        </div>

      </div>

    </el-drawer>
    <!-- 侧拉抽屉 end -->
    <!-- main content -->
    <div
      class="search-top"
      :class="
        type == 'product' || type == 'brand'
          ? 'search-top-product'
          : (plusSearch?'plus-search-top':'')
      "
    >
      <div class="content">
        <div class="crumb" v-if="type != 'product' && type != 'brand'">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>{{ value }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="result-title" v-if="type !== 'product' && type != 'brand'">
          Search Results for {{ value }}
        </div>
        <!-- 这里只有上面的搜索框不查询，只点击面包屑或者左侧菜单才显示这个，否则 应显示上面一行的精准查询 -->
        <div
          class="result-title"
          v-if="
            type === 'product' &&
            (value === '' || value === undefined || value === null)
          "
        >
          <span v-if="isNewProduct">New Releases</span><span v-else>{{ showSearchForObject.menuName }}</span>
        </div>
<!--
        <div class="result-title" v-if="type == 'brand'">All Products</div>
-->
        <div v-if="type === 'product'">
          <!-- 插入banner图 -->
          <!-- <div class="collection-pc-free" v-if="this.queryObject && this.queryObject.collectionId === '12d770e4-92f3-410a-9807-e4d966975caa'">
            <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/collection/collection-pc-50-free-shipping.png">
          </div>
          <div class="collection-mobile-free" v-if="this.queryObject && this.queryObject.collectionId === '12d770e4-92f3-410a-9807-e4d966975caa'">
            <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/collection/collection-mobile-50-free-shipping.png">
          </div> -->
        </div>
        <!-- 品牌PC端搜索条件  -->
        <template v-if="type == 'brand'">
          <!-- 品牌PC端 -->
          <div class="brand-select" v-if="!showMenuApp">
            <el-select
              v-model="selectData.sortValue"
              placeholder="Sort by"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':selectData.sortValue}"
              @change="getList(false)"
            >
              <el-option
                v-for="(item, id) in sortOption"
                :key="id"
                :label="item.lable"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-dropdown :hide-on-click="false" trigger="click" @visible-change="dropdownHandel()" style="margin:0 10px 15px 0;"
                         :class="{'cust-select-click':selectData.minPrice||selectData.maxPrice}">
              <span class="el-dropdown-link">
                {{PriceValue}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:10px;width:200px" :class="dropdownEdit?'hidden_dropdown':'show_dropdown'">
                <p style="margin:0 0 10px 0;color:#909399">Price Range</p>
                <el-input style="margin:0 0 10px 0;" v-model="selectData.minPrice" placeholder="$Min" @input="changePriceMin"></el-input>
                <el-input style="margin:0 0 10px 0;" v-model="selectData.maxPrice" placeholder="$Max" @input="changePriceMax"></el-input>
                <el-button style="width:100%;background:#262B2F;color:#fff" type="primary" @click="selectPriceHandel()">Apply</el-button>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </template>

        <!-- app端搜索条件 -->
        <template v-if="showMenuApp">
          <!-- <div class="filter_type_button" @click="">&& showMenuApp
            <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-1.png" alt="">
            <p>Story by</p>
          </div> -->
          <!-- 商品端 -->
          <div class="select-lists select-lists2" v-if="type == 'product'" >
            <div class="filter_type_button filter_type_button1">
              <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-1.png" alt="">
              <el-popover
                placement="bottom"
                width="245"
                trigger="click"
                v-model="popoverVisible">

                  <div class="story_box" v-for="(item, id) in sortOption" :key="id">
                    <div :class="selectData.sortValue == item.value? 'story_box_li li_color':'story_box_li'" @click="sortHandel(item.value)">{{item.lable}}</div>
                  </div>

                <el-button slot="reference" style="color: #5d5d5d;">Sort by</el-button>
              </el-popover>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="filter_type_button filter_type_button2" @click="phoneFilterHandel()">
              <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-0.png" alt="">
              <p>Filter</p>
            </div>
          </div>
          <!-- 品牌端 -->
          <div class="brand-app-search" v-else-if="type == 'brand'" >
              <div class="con-select" >
                <el-popover
                  placement="bottom"
                  width="245"
                  trigger="click"
                  v-model="popoverVisible">
                  <div class="story_box" v-for="(item, id) in sortOption" :key="id">
                    <div :class="selectData.sortValue == item.value? 'story_box_li li_color':'story_box_li'" @click="sortHandel(item.value)">{{item.lable}}</div>
                  </div>
                  <img slot="reference" src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-1.png" alt="">
                </el-popover>
              </div>
              <div class="con-select"  @click="phoneFilterHandel()">
                <img src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-0.png" alt="">
              </div>

              <div class="con-select2" :class="{'con-select2-active':tmpSelCategoryName}" @click="clickCate()">
                <span>{{ tmpSelCategoryName ? tmpSelCategoryName : 'Category' }}</span>
                <span class="down"></span>
              </div>
          </div>
        </template>

        <!-- 商品搜索页pc端端 -->
        <div class="select-lists" v-if="type == 'product' && !showMenuApp">
            <el-select
              v-model="selectData.sortValue"
              placeholder="Sort by"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':selectData.sortValue}"
              @change="getList(false)"
            >
              <el-option
                v-for="(item, id) in sortOption"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              >

              </el-option>
            </el-select>
            <el-select
              v-model="selectData.collectionBrandId"
              placeholder="Brand"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':selectData.collectionBrandId}"
              @change="getList(false)"
            >
              <el-option
                v-for="(item,index) in brandOption"
                :key="index"
                :label="item.collectionBrandName"
                :value="item.collectionBrandId"
              >
              </el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>
            </el-select>
            <el-dropdown :hide-on-click="false" class="cust-select" trigger="click" @visible-change="dropdownHandel()" style="margin:0 10px 15px 0;"
                         :class="{'cust-select-click':selectData.minPrice||selectData.maxPrice}"
            >
              <span class="el-dropdown-link">
                {{PriceValue}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:10px;width:200px" :class="dropdownEdit?'hidden_dropdown':'show_dropdown'">
                <p style="margin:0 0 10px 0;color:#909399">Price Range</p>
                <el-input style="margin:0 0 10px 0;" v-model="selectData.minPrice" placeholder="$Min" @input="changePriceMin"></el-input>
                <el-input style="margin:0 0 10px 0;" v-model="selectData.maxPrice" placeholder="$Max" @input="changePriceMax"></el-input>
                <el-button style="width:100%;background:#262B2F;color:#fff" type="primary" @click="selectPriceHandel()">Apply</el-button>
              </el-dropdown-menu>
            </el-dropdown>
            <el-select
            v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)"
              v-model="hairMaterialItem"
              placeholder="Hair Material"
              class="cust-select"
              popper-class="cust-select-option"
             :class="{'cust-select-click':hairMaterialItem}"
            @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in hairMaterialOption"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>

            </el-select>
            <el-select
            v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)"
              v-model="hairTextureItem"
              class="cust-select"
              popper-class="cust-select-option"
             :class="{'cust-select-click':hairTextureItem}"
            placeholder="Hair Texture"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in hairTextureOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>
            </el-select>
            <el-select
            v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId)"
              v-model="hairLaceDesignItem"
              placeholder="Hair Lace Design"
              class="cust-select"
              popper-class="cust-select-option"
             :class="{'cust-select-click':hairLaceDesignItem}"
            @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in hairLaceDesignOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>

            </el-select>
            <el-select
            v-if="this.queryObject && hairOpionsCateId.includes(this.queryObject.categoryId) || this.queryObject && hairOpionsCateId2.includes(this.queryObject.categoryId)"
              v-model="hairTypeItem"
              placeholder="Hair Type"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':hairTypeItem}"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in hairTypeOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>

            </el-select>

            <!-- dresses 相关属性 -->
            <el-select
              v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)"
              v-model="dressesStyleItem"
              placeholder="Style"
              class="cust-select"
              :class="{'cust-select-click':dressesStyleItem}"
              popper-class="cust-select-option"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in dressesStyleOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>

            </el-select>

            <el-select
              v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)"
              v-model="dressesDesignItem"
              placeholder="Design"
              class="cust-select"
              :class="{'cust-select-click':dressesDesignItem}"
              popper-class="cust-select-option"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in dressesDesignOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>
            </el-select>

            <el-select
              v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)"
              v-model="dressesFabricTypeItem"
              placeholder="Fabric Type"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':dressesFabricTypeItem}"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in dressesFabricTypeOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>
            </el-select>
            <el-select
              v-if="this.queryObject && dressesOpionsCateId.includes(this.queryObject.categoryId)"
              v-model="dressesOccasionItem"
              placeholder="Occasion"
              class="cust-select"
              popper-class="cust-select-option"
              :class="{'cust-select-click':dressesOccasionItem}"
              @change="addSelectList"
            >
              <el-option
                v-for="(item,index) in dressesOccasionOption"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
              <el-option key="clear" label="Clear" value="-1" class="select-clear"></el-option>
            </el-select>
        </div>

        <div :class="showMenuApp?'tags tags_margin':'tags'">
<!--          <el-tag v-if="selectData.sortValue"
            >Sort by:{{ sortOption[selectData.sortValue - 1] }}</el-tag
          >
          <el-tag
            v-if="selectData.collectionBrandId"
            closable
            @close="clearValue('collectionBrandId')"
            >{{brandOption.filter(item => item.collectionBrandId == selectData.collectionBrandId)[0].collectionBrandName}}</el-tag
          >
          <el-tag
            closable
            v-if="selectData.minPrice && confirmPriceEdit"
            @close="clearValue('minPrice')">minPrice:{{ selectData.minPrice }}</el-tag>
          <el-tag
            v-if="selectData.maxPrice && confirmPriceEdit"
            closable
            @close="clearValue('maxPrice')"
            >maxPrice:{{ selectData.maxPrice}}</el-tag
          >
         <el-tag
            closable
            v-if="hairMaterialItem"
            @close="clearValue('hairMaterialItem')">hairMaterial:{{ hairMaterialItem }}</el-tag>
            <el-tag
            closable
            v-if="hairLaceDesignItem"
            @close="clearValue('hairLaceDesignItem')">hairLaceDesign:{{ hairLaceDesignItem }}</el-tag>
            <el-tag
            closable
            v-if="hairTextureItem"
            @close="clearValue('hairTextureItem')">hairTexture:{{ hairTextureItem}}</el-tag>
            <el-tag
            closable
            v-if="hairTypeItem"
            @close="clearValue('hairTypeItem')">hairType:{{ hairTypeItem}}</el-tag>

            &lt;!&ndash; dresses 相关属性 &ndash;&gt;
            <el-tag
            closable
            v-if="dressesStyleItem"
            @close="clearValue('dressesStyleItem')">Style:{{ dressesStyleItem}}</el-tag>
            <el-tag
            closable
            v-if="dressesDesignItem"
            @close="clearValue('dressesDesignItem')">Design:{{ dressesDesignItem}}</el-tag>
            <el-tag
            closable
            v-if="dressesFabricTypeItem"
            @close="clearValue('dressesFabricTypeItem')">Fabric Type:{{ dressesFabricTypeItem}}</el-tag>
            <el-tag
            closable
            v-if="dressesOccasionItem"
            @close="clearValue('dressesOccasionItem')">Occasion:{{ dressesOccasionItem}}</el-tag>-->
        </div>
      </div>
    </div>

    <!-- 商品内容&分页 -->
    <div class="content" v-loading="loading">
      <CardCom
        :data="list"
        :type="type == 'product' ||type=='brand' ? 4 : 5"
        :spu="spuItem"
        :isShowBrandTag="isShowBrandTag"
        @showLogin="showLoginHandle"
        @clickHandle="clickHandle"
        :contentType="'shopping'"
        @setShowAn="setShowAn"
      ></CardCom>
      <PageCom
        :currentPage="currentPage"
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></PageCom>
    </div>
  </div>
  <footer-com
      v-if="type != 'product' && type != 'brand'"
      :value="showan"
      :key="showan"
    ></footer-com>
</div>
</template>

<script>
import HeaderCom from '../components/floatHeader.vue'
import CardCom from '../components/card.vue'
import FooterCom from '../home/components/homeFooter.vue'
import PageCom from '../components/pagination.vue'
import {getAction, postAction} from '@/api/manage.js'
import code from '../../pages/components/code'

export default {
  name: 'Head',
  components: { HeaderCom, CardCom, FooterCom, PageCom },
  props: {
    isShowBrandTag: {
      type: Boolean,
      default: true
    },
    brandId: {
      type: String
    },
    keyword: {
      type: String
    },
    type: {
      type: String
    },
    num: {
      type: Number
    },
    showLogin: {
      type: Function
    },
    setShowAnProduct: {
      type: Function
    },
    queryObject: {
      type: Object
    },
    cateArr: {
      type: Array
    }
  },
  data() {
    return {
      isNewProduct: localStorage.getItem('isNewProduct'),
      radioValue: '1',
      showDrawer: false,
      showCate: false,
      dropdownEdit: false,
      PriceValue: 'Price',
      loading: false,
      showan: false,
      menuName: '', // 在product点击某个分类查询的时候选择
      currentPage: 1,
      hairTex: ['1509440867079335937', '1509442231343820802', '1509442313896112130', '1509442337707175937', '1509442357189718017', '1509442376785506306', '1509466943667089410', '1509487166285721601'],
      hairOpionsCateId: ['1509442231343820802', '1509442357189718017', '1509442337707175937', '1509487166285721601', '1509440867079335937'],
      hairOpionsCateId2: ['1509442313896112130', '1509442376785506306'],
      dressesOpionsCateId: ['1460902038588407816'],
      // hairOpionsCateId:['1460902038600990720','1460902038600990723','1509442337707175937','1509487166285721601'],
      // hairOpionsCateId2:['1509442313896112130','1509442376785506306'],
      sortOption: [
        {value: 1, lable: 'Featured'},
        {value: 4, lable: 'Wholesale Price(Low to High)'},
        {value: 5, lable: 'Wholesale Price(High to Low)'},
        {value: 6, lable: 'New'}
      ],
      brandOption: [],
      hairMaterialOption: code.hairMaterialOption,
      hairTypeOption: code.hairTypeOption,
      hairTextureOption: code.hairTextureOption,
      hairLaceDesignOption: code.hairLaceDesignOption,
      hairColorOption: code.hairColorOption,

      dressesStyleOption: code.dressesStyleOption,
      dressesDesignOption: code.dressesDesignOption,
      dressesFabricTypeOption: code.dressesFabricTypeOption,
      dressesOccasionOption: code.dressesOccasionOption,

      characterValueList: [],
      hairMaterialItem: '',
      hairTypeItem: '',
      hairLaceDesignItem: '',
      hairTextureItem: '',

      dressesStyleItem: '',
      dressesDesignItem: '',
      dressesFabricTypeItem: '',
      dressesOccasionItem: '',

      confirmPriceEdit: false,
      activeNames: ['2', '3'],
      popoverVisible: false,

      selectData: {
        collectionBrandId: '',
        sortValue: 1,
        minPrice: '',
        maxPrice: ''
      },

      query: this.queryObject ? this.queryObject : {},
      list: [],
      total: 0,
      value: this.$route.params.value || '',
      plusSearch: localStorage.getItem('showOnHold') === 'true',
      tmpCategoryId: '',
      tmpSelCategoryName: '',
      spuItem: {},
      tempParams: {}
    }
  },
  watch: {
    $route: {
      handler: function (n, o) {
        this.getBrandOption()
        if (n.fullPath !== o.fullPath) {
          window.scrollTo({
            top: 0
          // behavior: 'smooth'
          })
          this.value = n.params.value
          if (n.fullPath.indexOf('search') > -1) {
            document.title = this.value + ' Wholesale | ShopVidi'
            document.querySelector('meta[name="keywords"]').setAttribute('content', this.value)
            document.querySelector('meta[name="description"]').setAttribute('content', null)
            mixpanel.track('v_search', {'keyword': this.value})
          }
          this.currentPage = 1
          this.getList(false)
        }
      },
      deep: true

      // this.value = n
      // // document.title = 'Purchase ' + n + ' Free Returns ＆ Net 60 Terms'
      // mixpanel.track('v_search', {'keyword': n})
      // this.getList()
    },
    currentPage(n, o) {
      console.log('>>>>currentPage<<<<<', n, o)
      localStorage.setItem('product-pre-page', o)
    }
  },
  computed: {
    showMenuApp() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  created() {
    localStorage.setItem('product-pre-page', 0)
    if (this.type === 'brand') {
      // document.title = 'Purchase ' + this.value + ' Free Returns ＆ Net 60 Terms'

    } else {
      if (this.query['menuName'] == 'New Releases') {
        this.selectData.sortValue = 6
      }
      this.getList(false)
      // buryingPoint('5', '', this.value)
    }
    this.getBrandOption()
  },
  mounted() {
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL) // 这里有没有都无所谓，最好是有以防万一
    //   window.addEventListener('popstate', this.goBack, false)
    // }
  },
  destroyed() {
    // window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    queryDataByBrand(itm) {
      this.tmpCategoryId = itm.id
      this.tmpSelCategoryName = itm.cateName
      this.showDrawer = false
      this.getList(false)
    },
    selectPriceHandel() {
      this.handlerPriceValue()

      this.dropdownEdit = true
      this.confirmPriceEdit = true
      this.getList(false)
    },
    handlerPriceValue() {
      this.PriceValue = 'Price'
      if (this.selectData.minPrice && this.selectData.maxPrice) {
        this.PriceValue = 'Price $' + this.selectData.minPrice + '-$' + this.selectData.maxPrice
      } else if (this.selectData.minPrice) {
        this.PriceValue = 'Price Min $' + this.selectData.minPrice
      } else if (this.selectData.maxPrice) {
        this.PriceValue = 'Price Max $' + this.selectData.maxPrice
      }
    },
    dropdownHandel() {
      this.dropdownEdit = false
    },
    getBrandOption() {
      if (this.queryObject) {
        let staticId = this.queryObject.collectionId ? this.queryObject.collectionId : this.queryObject.categoryId
        let type = this.queryObject.collectionId ? 1 : 0
        if (staticId) {
          getAction(`/es/gain/brand/` + staticId.replace('new', '') + `?type=` + type).then(response => {
            if (response.success) {
              this.brandOption = response.result
            } else {
              this.$message.warning(response.message)
            }
          })
        }
      }
    },
    phoneFilterHandel() {
      this.showDrawer = true
      this.showCate = false
    },
    clickCate() {
      this.showDrawer = true
      this.showCate = true
    },

    changePriceMin(value) {
      this.selectData.minPrice = value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      this.handlerPriceValue()
    },
    changePriceMax(value) {
      this.selectData.maxPrice = value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      this.handlerPriceValue()
    },
    addSelectList() {
      this.hairMaterialItem = (this.hairMaterialItem == '-1') ? '' : this.hairMaterialItem
      this.hairTextureItem = (this.hairTextureItem == '-1') ? '' : this.hairTextureItem
      this.hairLaceDesignItem = (this.hairLaceDesignItem == '-1') ? '' : this.hairLaceDesignItem
      this.hairTypeItem = (this.hairTypeItem == '-1') ? '' : this.hairTypeItem
      this.dressesStyleItem = (this.dressesStyleItem == '-1') ? '' : this.dressesStyleItem
      this.dressesDesignItem = (this.dressesDesignItem == '-1') ? '' : this.dressesDesignItem
      this.dressesFabricTypeItem = (this.dressesFabricTypeItem == '-1') ? '' : this.dressesFabricTypeItem
      this.dressesOccasionItem = (this.dressesOccasionItem == '-1') ? '' : this.dressesOccasionItem

      this.characterValueList = []
      if (this.hairMaterialItem) {
        this.characterValueList.push(this.hairMaterialItem)
      }
      if (this.hairTypeItem) {
        this.characterValueList.push(this.hairTypeItem)
      }
      if (this.hairLaceDesignItem) {
        this.characterValueList.push(this.hairLaceDesignItem)
      }
      if (this.hairTextureItem) {
        this.characterValueList.push(this.hairTextureItem)
      }

      // notes dresses 相关属性
      if (this.dressesStyleItem) {
        this.characterValueList.push(this.dressesStyleItem)
      }
      if (this.dressesDesignItem) {
        this.characterValueList.push(this.dressesDesignItem)
      }
      if (this.dressesFabricTypeItem) {
        this.characterValueList.push(this.dressesFabricTypeItem)
      }
      if (this.dressesOccasionItem) {
        this.characterValueList.push(this.dressesOccasionItem)
      }
      this.getList(false)
    },
    sortHandel(val) {
      this.selectData.sortValue = val
      this.popoverVisible = false
      this.getList(false)
    },
    handleChange() {
    },
    clearBrandHandel() {
      this.tmpCategoryId = ''
      this.tmpSelCategoryName = ''
      this.showDrawer = false
      this.getList(false)
    },
    clearAllHandel() {
      this.characterValueList = []
      this.hairMaterialItem = ''
      this.hairTypeItem = ''
      this.hairLaceDesignItem = ''
      this.hairTextureItem = ''
      this.dressesStyleItem = ''
      this.selectData = {
        collectionBrandId: '',
        sortValue: '',
        minPrice: '',
        maxPrice: ''
      }
    },
    closeHandel() {
      this.showDrawer = false
      this.getList(false)
    },
    showLoginHandle(item) {
      // 1.6.0 SEM 如果是购物车点击弹出的框 那么将参数放入localStorage里面
      localStorage.setItem('url', window.location.href)
      localStorage.setItem('selectData', JSON.stringify(this.tempParams))
      localStorage.setItem('spu', JSON.stringify(item))
      localStorage.setItem('currentPage', this.currentPage)
      this.$emit('showLogin')
    },
    setShowAn(data) {
      if (this.type == 'product') {
        this.$emit('setShowAnProduct', data)
      } else {
        this.showan = data
      }
    },
    clearValue(type) {
      this.selectData = {
        ...this.selectData,
        ...{
          [type]: ''
        }
      }
      this[type] = ''
      this.addSelectList()
      // this.getList()
    },
    getListHandle(data) {
      this.value = data
      this.getList(false)
    },
    getListCategoryId(selCategoryId) {
      this.tmpCategoryId = selCategoryId
      this.currentPage = 1
      this.getList(false)
    },
    async getList(isPage) {
      //add by cpgu 对于更改查询条件，则重置分页 2023/11/30 begin
      if (!isPage) {
        this.currentPage = 1
      }
      //end by cpgu

      // sem 如果缓存的url和当前url都一样的话才会使用缓存参数
      let selectDate = localStorage.getItem('selectData')
      if (selectDate) {
        if (window.location.href === localStorage.getItem('url')) {
          this.selectData = JSON.parse(selectDate)
          this.spuItem = JSON.parse(localStorage.getItem('spu'))
          this.currentPage = parseInt(localStorage.getItem('currentPage'))
        } else {
          this.selectData.collectionBrandId = (this.selectData.collectionBrandId == '-1') ? '' : this.selectData.collectionBrandId
        }
      } else {
        this.selectData.collectionBrandId = (this.selectData.collectionBrandId == '-1') ? '' : this.selectData.collectionBrandId
      }
      this.list = []
      this.showSearchForObject = {}
      this.showSearchForObject = { ...this.queryObject }
      this.loading = true
      let data = {
        ...this.selectData,
        ...this.query,
        ...{
          pageNo: this.currentPage,
          keyWords: this.value
        },
        characterValueList: this.characterValueList
      }
      if (this.type === 'product') {
        const type = data.categoryId ? 'categoryId' : 'collectionId'
        if (this.isNewProduct) {
          data[type] = localStorage.getItem('isNewProductId')
        }
        // 这里进行判断，对传的id进行拆解，因为要保证id的唯一性，所以这里对New Product的进行处理
        const id = data.categoryId ? data.categoryId : data.collectionId

        if (id !== undefined && id.indexOf('new') > -1) {
          data[type] = id.substring(3, id.length)
        }
      }
      // 来源品牌页
      if (this.type == 'brand') {
        const id = this.brandId
        data.keyWords = ''
        data.collectionBrandId = id
        if (this.tmpCategoryId) {
          data.categoryId = this.tmpCategoryId
        }
        // TODO 2.2.4 如果是品牌需要加一个参数给后端
        data.sortValue = 9
      }
      // SEM 把这个对象要存住每次更新 要更新实施参数
      this.tempParams = data
      let res = await postAction('/es/searchGoods', data)
      this.loading = false
      let arr = []
      this.total = res.result.total
      this.currentPage = res.result.current
      res.result.records.map((item) => {
        arr.push({
          ...item,
          ...{
            title: item.title,
            img: item.imgUrl,
            stockNum: item.stockNum || 0,
            totalSales: item.importCount || 0,
            netPrice: item.rrp,
            price: item.wsp
          }
        })
      })
      this.list = arr
      this.clearLocastorage()
    },
    clickHandle(id) {},
    handleSizeChange(val) {
      window.scrollTo({
        top: 700
      // behavior: 'smooth'
      })
      this.currentPage = 1
      this.selectData = {
        ...this.selectData,
        ...{
          pageSize: val
        }
      }
      this.$emit('pageChanged', val)
      this.getList(true)
    },
    /**
     * 清除缓存参数
     */
    clearLocastorage() {
      // 路由不是登录的话
      if (this.$route.path !== '/profile') {
        // 查询完数据将缓存数据删除
        localStorage.removeItem('selectData')
        localStorage.removeItem('url')
        localStorage.removeItem('currentPage')
        localStorage.removeItem('spu')
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      window.scrollTo({
        top: 700
        // behavior: 'smooth'
      })
      this.$emit('pageChanged', val)
      this.getList(true)
    }
    // goBack() {
    //   let prePage = localStorage.getItem('product-pre-page')
    //   if (prePage && prePage !== '0') {
    //     this.handleCurrentChange(parseInt(prePage))
    //   } else {
    //     console.log('history.go', prePage)
    //     history.go(-1)
    //   }
    // }
  }
}
</script>
<style scoped lang="less">
.collection-mobile-free{display: none;}
.collection-pc-free{margin-bottom: 10px;}
/deep/ .el-radio__input.is-checked+.el-radio__label{color: #262B2F !important;}
/deep/ .el-radio__input.is-checked .el-radio__inner{border-color: #262B2F !important;background: #262B2F !important;}
/deep/ .el-radio__label{color:#262B2F !important;line-height: 28px;}
/deep/ .el-button--primary,.el-button--primary:focus,.el-button--primary:hover{background: #262B2F !important;border-color: #262B2F !important;color: #FFF !important;}
/deep/ .el-button--default:focus,.el-button--default:active,.el-button--default:hover{background-color:#FFFFFF !important;color: #262B2F !important;border-color: #E1E1E1 !important;}
/deep/ .el-collapse-item__header{
  justify-content: start !important;
}
/deep/ .select-lists2 .el-button{
  border: none;
}
.select-clear{
  text-decoration: underline;
}
.drawer_box{
  box-sizing: border-box;
  display: flex;
  height: 100%;
  flex-direction: column;
  .drawer_main_content{
    flex: 1;
    overflow: scroll;
    padding: 0 10px;
  }
  .drawer_footer{
    width: 85%;
    height: 50px;
    box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    .footer_button{
      width: 256px;
      height: 45px;
    }
  }
  .header{
    display: flex;
    height: 54px;
    border-bottom: solid 1px #E1E1E1;
    align-items: center;
    font-family: Graphik;
    .head_title{
      font-size: 15px;
      font-weight: 500;
      color: #000000;
    }
    .head_clear{
      font-size: 14px;
      font-weight: 400;
      color: #262B2F;
      margin-left: 10px;
      text-decoration: underline;
    }
  }
  .cate_list{
    padding-bottom: 10px;
    // border-bottom: solid 1px #E1E1E1;
    .cate_list_title{
      font-size: 14px;
      font-family: Satoshi;
      font-weight: 500;
      margin: 20px 0 10px 0;
      color: #000000;
    }
    .cate_list_radio{
      display: flex;
     flex-direction: column;
    }
    .price_input{
      display: flex;
      align-items: center;
      span{
        margin: 0 10px;
        color: #8F8F8F;
      }
    }
    .price_cahnge_info{
      font-size: 14px;
      font-family: Satoshi;
      font-weight: 400;
      color: #262B2F;
      margin-bottom: 10px;
    }
  }
}
.el-dropdown-link{
  cursor: pointer;
  color: #C0C4CC;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.el-dropdown{
    width: 200px;
    height: 40px;
    background: #f4f4f4;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    line-height: 40px;
}
.show_dropdown{
  display: block;
}
.hidden_dropdown{
  display: none;
}
.story_box{
  padding: 0 20px;
  .story_box_li{
    height: 45px;
    line-height: 45px;
    border-bottom: #E1E1E1 solid 1px;
    color: #C0C4CC;
  }
  .li_color{
    color: #000000;
  }
}
.search {
  width: 1400px;
  margin: 0 auto;
  max-width: 100%;
}
.search-top {
  width: 100%;

  margin-top: 140px;
  padding-bottom: 20px;

  .result-title {
    font-size: 24px;
    font-family: Satoshi;
    font-weight: 500;
    line-height: 60px;
    color: #262b2f;
    text-align: left;
  }
  .result-subtitle{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    color: #5D5D5D;
    margin-bottom: 15px;
  }
  .select-lists {
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .filter_type_button{
      flex: 1;
      display: flex;
      border: solid 1px #E1E1E1;
      align-items: center;
      justify-content: center;
      height: 45px;
      font-size: 14px;
      font-family: Satoshi;
      font-weight: 400;
      color: #5D5D5D;
      img{
        width: 24px;
        height: 24px;
      }
    }

    .el-select {
      margin:0 10px 15px 0;
      .chang_title{
      margin-left:10px !important;
    }
    }
    .chang_title{
      margin-left:10px;
    }
    .chang_price{
      margin-bottom: 10px;
    }
  }
  .tags {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }
  .tags_margin{
    padding-top: 10px;
  }
  .content {
    width: 1400px;
    max-width: 100%;
    margin: 0 auto;
    min-width: 320px;
    // text-align: center;
  }
}
.search-top-product {
  width: 100%;
  margin-top: 0;
  padding-bottom: 20px;
  border-top: none;
}

.el-tag {
  margin-right: 10px;
  background: #5d5d5d;
  opacity: 1;
  border-radius: 15px;
  color: #ffffff;
  border-color: #fff;
}
.el-select {
  width: 200px;
  height: 40px;
  background: #f4f4f4;
  border: 1px solid #e1e1e1;
  opacity: 1;
  border-radius: 20px;
}

.crumb {
  // padding: 60px 0 20px 0;
  padding: 60px 0 10px 0;
  border-bottom: 1px solid #e1e1e1;
}
.plus-search-top{
  margin-top: 190px;
}
.brand-select{
  text-align: right;
}
.brand-app-search{
  display: flex;
  height: 45px;
  font-family: Satoshi;
  font-weight: 400;
  color: #5D5D5D;
  div:nth-child(n+2){
    margin-left: 20px;
  }
  .con-select,.con-select2{
    width: 40px;
    height: 40px;
    background: rgba(240,240,240,0.3900);
    position: relative;
  }
  .con-select{
    border-radius: 50%;
  }
  .con-select2{
    width: 180px;
    border-radius: 23px;
    span{
      position: relative;
      text-align: center;
      top: 10px;
      left: 10px;
    }
    .down{
      width: 8px;
      height: 7.5px;
      position: absolute;
      top: 6px;
      left: 145px;
      border-left: 1px solid #707070;
      border-bottom: 1px solid #707070;
      transform: translate(100%,100%) rotate(317deg);

    }
  }
  .con-select2-active{
    background: #262B2F;
    color: #fff;
  }

  img{
    width: 24px;
    height: 24px;
    position:relative;
    left: 8px;
    top: 8px;
  }
  /deep/ .el-select{
    height: 40px !important;
    margin-left: 20px;
    background: rgba(240,240,240,0.3900);
    width: 110px !important;
  }

}

@media screen and (max-width: 600px) {
  .crumb {margin-top: 20px;}
  .collection-mobile-free{display: block;margin-bottom: 10px;}
  .collection-pc-free{display: none;}
  .select-lists{
    display: flex;
    flex-flow: wrap;
  }
  .select-left {
    display: flex;
    flex-flow: wrap;
    .el-select {
      width: 44%;
      margin:5px 10px
    }
  }
  .el-select{width: 100%;}
  .search-top {
    box-sizing: border-box;
    // padding: 0 10px 10px;
    margin-top: 80px;
  }
  .plus-search-top{
    margin-top: 140px;
  }
  .search-top-product {
    margin-top: 0;
  }
  .select-right{
    width: 95%;
    padding: 10px;
  }
  .filter_type_button1{border: none !important;}
  .filter_type_button2{
      border: none !important;
  }
  .select-lists2{
    border: solid 1px #E1E1E1;
  }
  .brand-app-cate{
    a{
      text-decoration: none;
      color: #262613;
      font-size: 14px;
      font-weight: 400;
      line-height: 36px;

    }
  }
  .brand-app-cate-active{
    font-family: Satoshi-Medium;
    text-underline-offset:5px;
    padding-bottom: 2px;
    border-bottom: 1px solid #000;
  }

  .cust-collapse-itm{
    position: relative;
  }
  .cust-lg-i{
    content: " ";
    display: inline-block;
    height: 8px;
    width: 8px;
    border-width: 1px 1px 0 0;
    border-color: #303133;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: absolute;
    right: 5px;
  }
  .cust-lg-i-active{
    transform: translate(100%,100%) rotate(135deg);
    top: 5px;
    right: 15px;
  }
  .all-product{
    height: 50px;
    line-height: 50px;
    font-family: Satoshi-Medium;
  }
}
@media screen and (max-width: 420px) {
  .select-left {
    .el-select {
      width: 43%;
      margin:5px 10px
    }
  }
  .select-right{
    width: 93%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search/index.vue